import React, { Component } from 'react'
import { AssessPrint, } from '../../components/Assessment'
import { db } from '../../config/firebaseconfig'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assessmentActionCreators from '../../redux/modules/assessment'
import * as manageEducatorsActionCreators from '../../redux/modules/manageEducators'
import PDFreactor from '../../helpers/pdfreactor/PDFreactor'
import AssessPrintTemplate from '../../components/Assessment/AssessPrint/AssessPrintTemplate'
import ReactDOMServer from 'react-dom/server'
import queryString from 'query-string'
import fetchAllStudentScoring from '../../helpers/assessment/fetchAllStudentScoring';
import districtAdmin2 from '../../helpers/users/testing/districtAdmin2';
import initializeManageEducators from '../../helpers/users/initializeManageEducators';
import checkPrintPermission from '../../helpers/assessment/checkPrintPermission';


class AssessPrintContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      doc: '',
      isGeneratingPdf: false,
      error: '',
    }

    this.testUser = props.user || districtAdmin2
  }

  componentDidMount() {
    const qs = queryString.parse(this.props.location.search)
    if (qs.g) {
      if (!this.props.groupUAs) {
        this.props.fetchingGroupUAs()
        const groupUAId = this.props.match.params.userAssessmentId
        if (groupUAId) {
          db.collection('groupUA').get()
            .then((querySnapshot) => {
              let groupUAs = {}
              querySnapshot.forEach((doc) => {
                groupUAs[doc.id] = doc.data()
              })
              this.props.fetchingGroupUAsSuccess(groupUAs)
            })
            .catch(err => this.props.fetchingGroupUAsError(err))
        }
      }
    } else {
      if (!this.props.userAssessment) {
        this.props.assessmentInitialize()
        const userAssessmentId = this.props.match.params.userAssessmentId
        if (userAssessmentId) {
          db.collection('userAssessments').doc(userAssessmentId).get()
            .then((doc) => {
              if (doc.exists) {
                this.props.assessmentInitializeSuccess(doc.data())
              } else {
                this.props.assessmentInitializeError('Report not found.')
              }
            })
            .catch((err) => this.props.assessmentInitializeError(err))
        } else {
          this.props.assessmentInitializeError('Report not found.')
        }
      }
    }



    if (!this.props.nodes) {
      this.props.fetchingNodes()
      db.collection('knowledgeMapNodes').get()
        .then((querySnapshot) => {
          let nodes = {}
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (!data.deleted) {
              nodes[data.id] = data
            }
          })
          this.props.fetchingNodesSuccess(nodes)
        })
        .catch((err) => this.props.fetchingNodesError(err))
    }

    if (!this.props.items) {
      this.props.fetchingAllItems()
      db.collection('contentItems').get()
        .then((querySnapshot) => {
          let items = {}
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (!data.deleted) {
              items[data.itemId] = data
            }
          })
          this.props.fetchingAllItemsSuccess(items)
        })
        .catch((err) => this.props.fetchingAllItemsError(err))
    }

    if (this.props.items && this.props.nodes && (this.props.userAssessment || this.props.groupUAs)) {
      this.getPdf(this.props)
    }

    if (this.testUser.role !== 'Student') {
      const initActions = {
        initializing: this.props.initializing,
        initializingError: this.props.initializingError,
        initializingSuccess: this.props.initializingSuccess,
        set: {
          districts: this.props.setDistricts,
          schools: this.props.setSchools,
          educators: this.props.setEducators,
          students: this.props.setStudents,
          classes: this.props.setClasses,
        }
      }
      initializeManageEducators(this.testUser, initActions)
    }



  }

  componentWillReceiveProps(nextProps) {
    // refactor based on query string
    const studentReports = queryString.parse(this.props.location.search).sr
    const nextStudentReports = queryString.parse(nextProps.location.search).sr

    // check for if all needed user records data avail
    let prevRecordsCheck, nextRecordsCheck
    if (this.testUser.role === 'Student') {
      prevRecordsCheck = true
      nextRecordsCheck = true
    } else {
      prevRecordsCheck = !!(this.props.districts && this.props.schools && this.props.educators && this.props.classes && this.props.students)
      nextRecordsCheck = !!(nextProps.districts && nextProps.schools && nextProps.educators && nextProps.classes && nextProps.students)
    }
    if (
      (!this.props.userAssessment && nextProps.userAssessment) ||
      (!this.props.nodes && nextProps.nodes) ||
      (!this.props.groupUAs && nextProps.groupUAs) ||
      (!this.props.items && nextProps.items) ||
      (!prevRecordsCheck && nextRecordsCheck) ||
      (studentReports !== nextStudentReports)
    ) {
      if ((nextProps.userAssessment || nextProps.groupUAs) &&
        nextProps.nodes &&
        nextProps.items &&
        nextRecordsCheck
      ) {
        this.getPdf(nextProps)
      }
    }
  }

  getPdf(props = this.props) {
    // const pdfReactor = new PDFreactor('https://pdf.masteryprep.com:8443/service/rest')
    const pdfReactor = new PDFreactor('https://pdf.masteryprep.com/legacy/service/rest')
    // const pdfReactor = new PDFreactor('https://cloud.pdfreactor.com/service/rest')
    // const pdfReactor = new PDFreactor('https://206.189.160.39:9423/service/rest')
    let input
    const isGroup = queryString.parse(props.location.search).g

    if (isGroup) {
      this.setState({ isGeneratingPdf: true })
      const qs = queryString.parse(props.location.search)
      const assessmentId = qs.a
      const year = qs.y
      const printStudentReports = qs.sr
      const gUA = props.groupUAs[props.match.params.userAssessmentId]
      input = gUA[year][assessmentId]
      input = {...input, district: gUA.district, school: gUA.school, teacher: gUA.teacher}
      const permissionQ = checkPrintPermission(this.testUser, input)
      const usersData = {
        districts: props.districts,
        schools: props.schools,
        educators: props.educators,
        classes: props.classes,
        students: props.students,
      }
      if (!permissionQ) {
        return this.setState({
          isGeneratingPdf: false,
          error: "Sorry, you don't have permission to access this report."
        })
      }
      fetchAllStudentScoring(input.students)
        .then((studentScoring) => {
          const doc = ReactDOMServer.renderToStaticMarkup(
            <AssessPrintTemplate
              userAssessment={input}
              nodes={props.nodes}
              isGroup={isGroup ? true : false}
              items={props.items}
              studentScoring={studentScoring}
              user={this.testUser}
              usersData={usersData}
              printStudentReports={printStudentReports}
            />
          )
          const config = {
            addLinks: true,
            javaScriptMode: 'ENABLED_TIME_LAPSE',
            document: doc
          }
          pdfReactor.convert(config, (result) => {
            this.setState({ doc: result.document, isGeneratingPdf: false })
          }, (err) => {
            console.log(err)
            this.setState({ error: err, isGeneratingPdf: false })
          })
        })
        .catch(err => {
          console.log(err)
          this.setState({error: err, isGeneratingPdf: false})
        })
    } else {
      input = this.props.userAssessment
      this.setState({ isGeneratingPdf: true })
      const permissionQ = checkPrintPermission(this.testUser, input)
      if (!permissionQ) {
        return this.setState({
          isGeneratingPdf: false,
          error: 'permission'
        })
      }
      const doc = ReactDOMServer.renderToStaticMarkup(
        <AssessPrintTemplate
          userAssessment={input}
          nodes={props.nodes}
          isGroup={isGroup ? true : false}
          items={props.items}
          user={this.testUser}
        />
      )
      const config = {
        document: doc,
      }
      pdfReactor.convert(config, (result) => {
        this.setState({ doc: result.document, isGeneratingPdf: false })
      }, (err) => {
        console.log(err)
        this.setState({ error: err, isGeneratingPdf: false })
      })
    }
  }

  render() {
    const { userAssessment, nodes, history, location, } = this.props
    const { doc, error, isGeneratingPdf } = this.state
    const { goBack } = history
    const isGroup = queryString.parse(location.search).g
    return (
      <AssessPrint
        userAssessment={userAssessment}
        nodes={nodes}
        doc={doc}
        error={error}
        isGeneratingPdf={isGeneratingPdf}
        goBack={goBack}
        search={location.search}
        isGroup={isGroup}
      />
    )
  }
}

export default connect(
  (state) => ({
    userAssessment: state.assessment.userAssessment,
    nodes: state.assessment.nodes,
    groupUAs: state.assessment.groupUAs,
    items: state.assessment.items,
    districts: state.manageEducators.districts,
    schools: state.manageEducators.schools,
    educators: state.manageEducators.educators,
    classes: state.manageEducators.classes,
    students: state.manageEducators.students,
    user: state.users.testUser,
  }),
  (dispatch) => bindActionCreators({ ...assessmentActionCreators, ...manageEducatorsActionCreators }, dispatch)
)(AssessPrintContainer)


// WEBPACK FOOTER //
// ./src/containers/Assessment/AssessPrintContainer.js